const RamaisHome = () => import(/* webpackChunkName: "group-pabx-cadastros-ramais" */ '../_views/RamaisHome')
const CadastroRamais = () => import(/* webpackChunkName: "group-pabx-cadastros-ramais" */ '../_views/CadastroRamais')
const AtualizarRamais = () => import(/* webpackChunkName: "group-pabx-cadastros-ramais" */ '../_views/AtualizarRamais')
const CadastroMultiplosRamais = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-ramais" */ '../_views/CadastroMultiplosRamais')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'ramais',
    component: RamaisHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Ramais',
  },
  {
    path: 'ramais/criar',
    component: CadastroRamais,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'ramais/criar',
  },
  {
    path: 'ramais/atualizar/:_id',
    component: AtualizarRamais,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'ramais/atualizar',
    props: true,
  },
  {
    path: 'ramais/criar-multiplos',
    component: CadastroMultiplosRamais,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'ramais/criar-multiplos',
  },
]
